import styles from './TableCardView.module.scss';
import { Button, Select, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import type { TableColumnType } from '../Table';
import type { CardSortState } from './TableCardViewControls';
import { getColumnKey, getColumnLabel } from './tableCardViewUtils';
import { Icon } from '@/components/Icon';

interface Props<T> {
  columns: TableColumnType<T>[];
  sort: CardSortState;
  onSortChange: (sort: CardSortState) => void;
}

export function TableCardViewSortControls<T>(props: Props<T>) {
  const { columns, sort, onSortChange } = props;
  const { t } = useTranslation();
  const isDescending = sort.order === 'descend';

  const toggleSortOrder = () => {
    onSortChange({
      ...sort,
      order: isDescending ? 'ascend' : 'descend',
    });
  };

  const onSortColumnChange = (key: string | undefined) => {
    onSortChange({ key, order: key ? sort.order ?? 'ascend' : undefined });
  };

  return (
    <div className={styles.sortRow}>
      <Select<string>
        className={styles.sortSelect}
        allowClear
        placeholder={t('table.sortBy')}
        value={sort.key}
        onChange={onSortColumnChange}
        options={columns.map((column, index) => ({
          label: getColumnLabel(column),
          value: getColumnKey(column, index),
        }))}
      />
      <Tooltip
        title={isDescending ? t('table.descending') : t('table.ascending')}
      >
        <Button
          icon={
            <Icon type={isDescending ? 'sort-descending' : 'sort-ascending'} />
          }
          type="link"
          disabled={!sort.key}
          onClick={toggleSortOrder}
        />
      </Tooltip>
    </div>
  );
}
